class PlannerYourDetailsController {
    constructor() {
        this.model = plannerApplication.yourProfile.getYourDetails();
        this.view = new YourDetailsView({model: this.model});

        this.view.inputFirstName.val(this.model.getFirstName())
            .bindChangedHandler(this.onUpdated.bind(this));

        this.view.inputLastName.val(this.model.getLastName())
            .bindChangedHandler(this.onUpdated.bind(this));

        this.view.inputEmail.val(this.model.getEmail())
            .bindChangedHandler(this.onUpdated.bind(this));

        this.view.agreeTcs.setChecked(this.model.hasAgreedTCs())
            .bindChangedHandler(this.onUpdated.bind(this));

        this.invalid = false;

        this.onUpdated();
    }

    onUpdated() {
        this.model.updateTo(
            this.view.inputFirstName.valueTrimmed(),
            this.view.inputLastName.valueTrimmed(),
            this.view.inputEmail.valueTrimmed(),
            this.view.agreeTcs.isChecked());
        this.invalid = !this.model.isComplete();
        this.view.btnNext.enableNextBtnIf(!this.invalid);

        plannerApplication.userDataUpdated();
    }

    showValidationErrors() {
        this.view.inputFirstName.validateIf(fieldIsNotEmpty(this.model.getFirstName()));
        this.view.inputLastName.validateIf(fieldIsNotEmpty(this.model.getLastName()));
        this.view.inputEmail.validateIf(fieldIsEmail(this.model.getEmail()));
        this.view.agreeTcs.validateIf(this.model.hasAgreedTCs());
    }
}
